import {
  FormControl,
  MenuItem,
  Select,
  Typography,
  type SelectChangeEvent,
} from '@mui/material'
import { useLayout } from 'hooks/useLayout'
import { useState } from 'react'
import { type PerformanceTrendsFilterType } from 'utils/util'

export const PerformanceTrendsTypes: PerformanceTrendsFilterType[] = [
  'YearToDate',
  'LastYear',
]

const performanceTrendsTypeLabels: Record<PerformanceTrendsFilterType, string> =
  {
    YearToDate: 'Year to Date',
    LastYear: 'Last Year',
  }

interface SelectProps {
  onSelect: (typ: PerformanceTrendsFilterType) => void
  performanceTrendsType: PerformanceTrendsFilterType
  disabledValue: boolean
}

export const SelectPerformanceTrendsFilterType = ({
  onSelect,
  performanceTrendsType,
  disabledValue,
}: SelectProps) => {
  const isMobile = useLayout()
  const [selectedValue, setSelectedValue] =
    useState<PerformanceTrendsFilterType>()

  const handleChange = (
    event: SelectChangeEvent<PerformanceTrendsFilterType>
  ) => {
    setSelectedValue(
      event.target.value as unknown as PerformanceTrendsFilterType
    )
    onSelect(event.target.value as unknown as PerformanceTrendsFilterType)
  }

  return (
    <FormControl
      sx={{
        width: isMobile.isMobile ? '180px' : '240px',
        minWidth: isMobile.isMobile ? '180px' : '240px',
        flexShrink: 0,
      }}
    >
      <Select
        value={(performanceTrendsType || selectedValue) ?? ''}
        disabled={disabledValue}
        onChange={handleChange}
        sx={{ width: '100%' }}
        displayEmpty
        renderValue={(selectedItem) => {
          if (!selectedItem) {
            return 'Year to Date'
          }

          return (
            <Typography>
              {performanceTrendsTypeLabels[selectedItem] ?? selectedItem}
            </Typography>
          )
        }}
        variant="outlined"
        required={false}
        inputProps={{ 'aria-label': 'Without label' }}
      >
        <MenuItem value={'YearToDate'}>{'Year to Date'}</MenuItem>
        <MenuItem value={'LastYear'}>{'Last Year'}</MenuItem>
      </Select>
    </FormControl>
  )
}
